import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavController } from '@ionic/angular';
import { UserProvider } from '../../providers/user/user';
import { SessionProvider } from '../../providers/session/session';
import { AppDetectorProvider } from '../../providers/detector/detector';
import { Router } from '@angular/router';


/**
 * Generated class for the WelcomePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-welcome',
  templateUrl: 'welcome.html',
  styleUrls:['./welcome.scss']
})
export class WelcomePage {

  constructor(
    public router:Router,
  private appDetector: AppDetectorProvider,
    public userService: UserProvider,
    public navCtrl: NavController,
    public translate: TranslateService,
    private sessionService: SessionProvider,
    private detectorProvider: AppDetectorProvider
  ) {
  }

  ionViewDidEnter() {
  }

  skip() {
    let page = this.appDetector.isEventsApp() ? '/ event-search' : '/tabs';
    this.navCtrl.navigateForward(page);
  }

  public isLoged(): boolean {
    return this.sessionService.isLoged;
  }

  showLogin() {
    if (this.detectorProvider.isHellaApp()) {
      this.sessionService.getToken(false, false).then(token => {
        // this.app.getRootNav().push(IdRegistrationPage);
        this.navCtrl.navigateForward('/auth/id-registration');
      });
    } else {
      // this.app.getRootNav().push(LoginPage)
      this.navCtrl.navigateForward('/auth/login');
    }
  }

}
